import { IsOptional, IsString, IsUUID, ValidateIf, MaxLength } from 'class-validator';

export class CreateMandatoryProblemReportingConfigRequestDto {
    /**
     * Assessment Organization (text field, not UUID)
     * @example 'Jazz Pharmaceuticals'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    assessmentOrganization?: string;

    /**
     * Assessment Email
     * @example 'assessment@client.com'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    assessmentEmail?: string;

    /**
     * Reporting to HC Organization (text field, not UUID)
     * @example 'Q&C'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    reportingToHCOrganization?: string;

    /**
     * Reporting to HC Email
     * @example 'hc.reports@qccompany.com'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    reportingToHCEmail?: string;

    /**
     * Notes
     * @example 'Follow FDA MDR requirements and ISO 14971 risk management'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
